<!-- @format -->
@if (isMobile()) {
	<!-- sticky shipping filter bar for mobile -->
	<div
		#mobileShippingFilter
		class="mobile-shipping-filter border-bottom hmf-display-flex hmf-display-lg-none hmf-align-items-center hmf-position-relative sticky-element fill-base"
		[class.hmf-elevated-shadow]="
			isFilterContainerSticky() && !(compareCheckboxEnabled() && compareBarProducts()?.length)
		">
		<div class="hmf-display-flex hmf-flex-nowrap hmf-overflow-x-auto hide-scroll-bar">
			@if (exposedFiltersSticky()) {
				<div
					class="exposed-filters-mobile hmf-display-flex hmf-flex-nowrap hmf-overflow-x-auto hide-scroll-bar hmf-ml-xxl hmf-pl-xxxs">
					@for (
						filter of exposedFilters();
						let i = $index;
						track trackFilterName(i, filter)
					) {
						<plp-components-exposed-filters
							class="hmf-pl-xxs hmf-py-xs hmf-my-xxxxs"
							[isMobile]="isMobile()"
							[filter]="filter"
							[isOpen]="isExposedFilterOpen(filter)">
						</plp-components-exposed-filters>
					}
				</div>
			} @else {
				<plp-components-shipping-filter
					id="shipping-options"
					class="hmf-display-block hmf-display-sm-flex hmf-my-m-0"
					[isMobile]="isMobile()"
					[disabled]="isDisabled()">
				</plp-components-shipping-filter>
			}
		</div>
		<!-- mobile filter icon when filter is selected-->
		<div
			class="filter-count-button-container hmf-display-flex hmf-position-absolute hmf-mt-xxs">
			<button
				class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-body-bold-m hmf-soft-radius filter-count-button hmf-mx-xxs"
				(click)="openFilterDrawer()">
				<homefield-icon name="list-filter-outline"></homefield-icon>
				@if (selectedFilterCount()) {
					<span class="filter-count hmf-position-absolute hmf-round-radius">
						{{ selectedFilterCount() }}
					</span>
				}
				<div class="hmf-pt-0 hmf-body-s filter-and-sort">Filter</div>
			</button>
			<div
				class="divider hmf-display-none"
				[class.hmf-display-block]="(exposedFiltersSticky()) || !isFulfillmentFiltersSelected()"></div>
		</div>
	</div>
	<!-- exposed filters + sort: NOT sticky, slides under the filter bar on scroll -->
	<div class="exposed-filter-sort-mobile hmf-span-12 hmf-display-block hmf-display-lg-none fill-base">
		@if (exposedFiltersSticky()) {
			<plp-components-shipping-filter
				class="hmf-display-block hmf-display-sm-flex hmf-my-m-0 border-bottom"
				[isMobile]="isMobile()"
				[disabled]="isDisabled()"
				[mobileSelectionPosition]="'left'">
			</plp-components-shipping-filter>
		} @else if(exposedFiltersEnabled() && exposedFilters()?.length) {
			<div
				class="exposed-filters-mobile border-bottom hmf-display-flex hmf-flex-nowrap hmf-overflow-x-auto hide-scroll-bar">
				@for (
					filter of exposedFilters();
					let i = $index;
					track trackFilterName(i, filter)
				) {
					<plp-components-exposed-filters
						class="hmf-pl-xxs hmf-py-xs"
						[isMobile]="isMobile()"
						[filter]="filter"
						[isOpen]="isExposedFilterOpen(filter)">
					</plp-components-exposed-filters>
				}
			</div>
		}

		<div
			id="sort-container-mobile"
			class="border-bottom hmf-py-xxxs hmf-display-flex hmf-w-100 hmf-px-xs hmf-align-items-center">
			<div class="hmf-pl-xxxs hmf-body-bold-m">SORT:</div>
			<plp-components-sort
				[isDisabled]="isDisabled()"
				[sortByCustomerRatingEnabled]="sortByCustomerRatingEnabled()"></plp-components-sort>
		</div>
	</div>
	@if (compareCheckboxEnabled() && compareBarProducts()?.length) {
		<plp-components-compare-bar
			#compareBarMobile
			id="compare-bar-mobile"
			class="compare-bar-mobile hmf-w-100 sticky-element hmf-display-block hmf-display-lg-none"
			[compareList]="compareBarProducts()"
			[showThumbnails]="false"
			[actionButtonsSize]="'small'"
			[class.hmf-elevated-shadow]="isFilterContainerSticky()">
		</plp-components-compare-bar>
	}
} @else {
	<!-- sticky filter container for desktop -->
	<div
		#desktopTopBarContainer
		class="desktop-filter-bar-container hmf-display-none hmf-display-lg-block hmf-w-100 sticky-element"
		[class.hmf-elevated-shadow]="
			isFilterContainerSticky() && !(compareCheckboxEnabled() && compareBarProducts()?.length)
		">
		<div class="desktop-filter-bar hmf-display-flex hmf-span-12 fill-base">
			@if (!exposedFiltersEnabled() || (exposedFiltersEnabled() && exposedFilters()?.length === 0)) {
				<div
					class="hmf-display-inline-flex hmf-align-items-center hmf-pl-s filter-container-desktop">
					<homefield-icon
						name="list-filter-outline"
						height="16px"
						width="16px"
						class="hmf-mr-xxs"></homefield-icon>
					<div class="hmf-body-bold-m filter-label">Filter</div>
				</div>
			}
			<div
			class="shipping-exposed-filters-sort-container hmf-position-relative hmf-display-flex hmf-span-12 hmf-justify-content-between hmf-align-items-center hmf-flex-nowrap hmf-px-s">
				<div class="scrollable-area-wrapper hmf-position-relative">
					@if (exposedFiltersEnabled()) {
						<shared-components-carousel-button
							class="hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
							[class.hmf-display-block]="showLeftArrow()"
							[previous]="true"
							[ariaLabel]="'Scroll Left'"
							[showLeftArrow]="showLeftArrow()"
							[size]="'small'"
							[iconSize]="'medium'"
							(clickEvent)="scrollFilters('left')">
						</shared-components-carousel-button>
						<shared-components-carousel-button
							class="hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
							[class.hmf-display-block]="showRightArrow()"
							[previous]="false"
							[ariaLabel]="'Scroll Right'"
							[showRightArrow]="showRightArrow()"
							[size]="'small'"
							[iconSize]="'medium'"
							(clickEvent)="scrollFilters('right')">
						</shared-components-carousel-button>
					}
					<div
						#filtersShippingScrollableArea
						class="hmf-display-flex hmf-flex-nowrap hmf-flex-m-grow hmf-overflow-x-auto hide-scroll-bar hmf-justify-content-between hmf-align-items-center"
						(scroll)="onFilterScroll()">
						<!-- shipping options -->
						@if(!moveFulfillmentOptions()) {
							<plp-components-shipping-filter
								class="shipping-filters-desktop hmf-justify-content-flex-end hmf-align-items-center hmf-flex-m-grow hmf-ml-s hmf-ml-m-0"
								[disabled]="isDisabled()"
								[isMobile]="isMobile()">
							</plp-components-shipping-filter>
						}
						<!-- Exposed filters -->
						@if (exposedFiltersEnabled() && exposedFilters()?.length) {
							<div class="exposed-filters-divider hmf-mx-xs"
								[class.hmf-display-none]="moveFulfillmentOptions()"
							></div>
							@for (
								filter of exposedFilters();
								let i = $index;
								track trackFilterName(i, filter)
							) {
								<plp-components-exposed-filters
									class="hmf-mr-xxs"
									[isMobile]="isMobile()"
									[filter]="filter"
									[isOpen]="isExposedFilterOpen(filter)"
									(desktopPopoverRequested)="openExposedFilterPopover($event)"
									(desktopPopoverTabRequested)="focusActiveExposedFilterContent()"
									(desktopPopoverShiftTabRequested)="closeExposedFilterPopover()">
								</plp-components-exposed-filters>
							}
						}
					</div>
				</div>
				<!-- sort component -->
				<div
					class="hmf-display-flex hmf-justify-content-flex-end hmf-align-items-center hmf-ml-l sort-container hmf-my-s">
					<homefield-icon
						class="hmf-mr-xxxs"
						name="arrow-swap-vertical-outline"
						width="16px"
						height="16px"></homefield-icon>
					<div class="hmf-py-xxs hmf-mr-xxs hmf-body-bold-m">SORT:</div>
					<plp-components-sort
						class="hmf-mr-xxs"
						[isDisabled]="isDisabled()"
						[sortByCustomerRatingEnabled]="sortByCustomerRatingEnabled()"
						(tabPressed)="handleFocusOut()">
					</plp-components-sort>
				</div>
			</div>
		</div>
	</div>
	@if (compareCheckboxEnabled() && compareBarProducts()?.length) {
		<div
			#compareBarDesktopContainer
			class="compare-bar-desktop-container hmf-w-100 sticky-element hmf-display-none hmf-display-lg-block"
			[class.hmf-elevated-shadow]="isFilterContainerSticky()">
			<plp-components-compare-bar
				id="compare-bar-desktop"
				class="compare-bar-desktop hmf-display-block"
				[compareList]="compareBarProducts()"
				[showThumbnails]="true"
				[actionButtonsSize]="'medium'"
				(tabPressed)="handleFocusOut()"></plp-components-compare-bar>
		</div>
	}
	@if (exposedFiltersEnabled() && activeExposedFilterAnchor() && activeExposedFilter()) {
		<hmf-popover
			class="desktop-exposed-filter-popover"
			[anchorElement]="activeExposedFilterAnchor()!"
			[open]="exposedFilterPopoverOpen()"
			variant="configurable"
			position="bottom"
			alignment="center"
			padding="default"
			[displayCaret]="true"
			(handleCloseModule)="closeExposedFilterPopover()">
			<div
				#desktopExposedFilterContent
				class="exposed-filters-container"
				tabindex="-1"
				(keydown.tab)="handleExposedFilterContentTab($event)"
				(keydown.shift.tab)="handleExposedFilterContentTab($event)">
				<plp-components-filter
					[id]="'filter-' + activeExposedFilter()?.attrIdentifier"
					[filter]="activeExposedFilter()!"
					[isMobile]="isMobile()"
					[isPlp3Template]="isPlp3Template()"
					[disabled]="isDisabled()"
					[isExposedFilter]="true"
					[refinementSource]="refinementSource"
					(filterSelectionCommitted)="closeExposedFilterPopover()">
				</plp-components-filter>
			</div>
		</hmf-popover>
	}
}
